import {Button, SimpleGrid} from "@mantine/core";
import IconCrossMark from "../../Icon/IconCrossMark";
import s from './KeyBoard.module.scss';
import {IconHandClick} from "@tabler/icons-react";
const keyBoardButtons = [1, 2, 3, 4, 5, 6, 7, 8, 9];
const KeyBoard = ({  addChar, removeChar}) => {
    return (
        <SimpleGrid cols={3} dir="ltr" className="">
            {
                keyBoardButtons.map(item => (
                    <Button key={item} variant="filled" size="lg" radius="lg" className={s.button} onClick={() => addChar(item)}>
                        {item}
                    </Button>
                ))
            }
            <Button variant="filled" size="lg" radius="lg" className='inline-flex justify-center bg-purple-700 hover:bg-greenTwo text-greenOne hover:text-greenOne text-xl' type="submit" leftSection={<IconHandClick className="-ml-4 mr-4 animate-bounce" />}>
                ورود
            </Button>
            <Button variant="filled" size="lg" radius="lg" className={s.button} onClick={() => addChar(0)}>
                0
            </Button>
            <Button variant="filled" size="lg" radius="lg" className={s.button} onClick={removeChar}>
                <IconCrossMark/>
            </Button>
        </SimpleGrid>
    )
}
export default KeyBoard;